import React, { Component } from 'react';
import Apng from 'react-apng';
import clientApi from '../../api/client';
import Toast from '../../utils/toast';
// import Load from '../../template/Load/Load';
import {apiDefine} from '../../api/web';
import { decodeParams } from '../../utils/tools';

import './Question.less';
import exampleIcon from '../../static/images/homework-new/play_apng.png';
import recordLight from '../../static/images/homework-new/light.png';

class Question extends Component {
    constructor(props){
        super(props);
        this.clientWidth = document.body.clientWidth || document.documentElement.clientWidth;
        this.countInit = 1600 / this.clientWidth;
        this.defaultStep = props.defaultStep; // 传入初始步骤
        this.state = {
            type: props.type, // 关卡类型
            defaultTime: props.defaultTime, // 录音评测保护时间
            recordStudentStatus: 'gray', // 我的录音按钮状态
            recordStatus: 'gray', // 示例录音按钮状态
            questionInfo: props.questionInfo,  // 作业信息
            eventTrackingType: props.type === 'archery' ? 'Arrow' : 'Fireworks',
        };
        this.timeOutArr = [];
    }
    componentDidMount = () => {
        this.setStep(this.props.defaultStep);
        apiDefine({apiName:'evaluateResult',fn:this.evaluateResult}); // 定义接收录音结果方法
        apiDefine({apiName:'homeworkPlaybackFinished',fn:this.homeworkPlaybackFinished}); // 定义接收录音播放终止方法
        apiDefine({ apiName: 'storageEvaluatedAudio', fn: this.storageEvaluatedAudio }); // 定义接收录音地址方法
        this.initAudio();
    }
    componentWillReceiveProps(nextProps){
        this.setState(nextProps)
    }
    componentWillUnmount(){
        this.timeOutArr.map(ele => (clearTimeout(ele)));
    }

    initAudio = () => {
        if(this.audioExample){
            this.audioExample.onerror = () => {
                Toast.info({ text: '音频加载失败, 请重试' });
                // this.audioExample.load();
            };
            this.timeOutArr.push(
                setTimeout(() => {
                    const { defaultTime } = this.state;
                    const { level0 } = this.props;
                    const mod = level0 ? 1.5 : 1.8;
                    this.duration = defaultTime;
                    try {
                        this.duration = this.audioExample.duration ? this.audioExample.duration * mod + 1 : defaultTime;
                    } catch (error) {
                        console.log(error)
                    }
                    this.setStep('step1')
                }, 500)
            );
        }
    }

    // 播放示例音频
    playExample = () => {
        const { recordStudentStatus, recordExampleStatus, step, eventTrackingType } = this.state;
        if(step === 'step2' || recordExampleStatus === 'playing') return false;
        clientApi.homeworkPlayback({play:false});
        this.example.play();
        this.audioExample.play();
        clientApi.eventTracking({eventType:`c2_app_HomeWork_${eventTrackingType}_Play`});
        this.setState({
            recordExampleStatus:'playing',
        });
        if(recordStudentStatus === 'playing' && step !== 0){
            this.setState({
                recordStudentStatus: 'pause',
            })
        }
        this.audioExample.onended = () => {
            this.example.stop();
            this.setState({
                recordExampleStatus:'pause',
            });
        }
    }
    // 播放当前录制音频
    playStudent = () => {
        const { recordStudentStatus, eventTrackingType } = this.state;
        if(this.state.step === 'step1' || recordStudentStatus === 'playing' || recordStudentStatus === 'gray') return false;
        this.audioExample.pause();
        this.example.stop();
        clientApi.homeworkPlayback({play:true});
        clientApi.eventTracking({eventType:`c2_app_HomeWork_${eventTrackingType}_RecordPlay`});
        this.setState({
            recordStudentStatus:'playing',
            recordExampleStatus:'pause'
        });
    }

    // 客户端录音播放终止
    homeworkPlaybackFinished = () => {
        const { step } = this.state;
        if(step === 'step1') return false;
        this.setState({recordStudentStatus:'pause'});
    }

    //设置当前步骤 暴露给父组件
    setStep = nextStep =>{
        const { step } = this.state;
        if(nextStep === step ) return false;
        if(nextStep === 'step1'){
            this.setState({
                recordStatus: 'active',
                done: false,
                recordStudentStatus: 'gray',
            })
        }
        if(nextStep === 'step2'){
            this.setState({
                recordStatus: 'gray',
            })
        }
        if(nextStep === 'step3') {
            this.setState({
                recordStudentStatus: 'pause',
                done: true
            })
        }
        if(nextStep === 'step4') {
            this.setState({
                recordStudentStatus: 'pause'
            })
        }
        this.setState({step: nextStep})
    }

    //重录
    restart = (next) => {
        const { eventTrackingType } = this.state;
        this.setState({
            done: false,
            recordStudentStatus: 'gray',
            recordExampleStatus: 'pause',
            words: []
        });
        const nextStep = next ? this.defaultStep : 'step1';
        this.setStep(nextStep);
        clientApi.homeworkPlayback({play: false});
        this.audioExample.load();
        this.example.stop();
        this.props.restart();
        !next && clientApi.eventTracking({eventType:`c2_app_HomeWork_${eventTrackingType}_Rerecord`});
    }
    nextQuestion = () => {
        const { score, eventTrackingType } = this.state;
        const { isLast } = this.props;
        this.props.nextQuestion(score);
        this.restart(true);
        if(isLast) clientApi.eventTracking({eventType:`c2_app_HomeWork_${eventTrackingType}_Done`});
        else clientApi.eventTracking({eventType:`c2_app_HomeWork_${eventTrackingType}_Next`});
    }
    // 发起录音评测
    recordTest = (e) => {
        const { questionInfo, eventTrackingType } = this.state;
        const { parameters } = this.props;
        const { type } = this.props;
        this.setState({
            hasClick: true,
            step:'step2',
            recordStatus: 'gray',
            recordExampleStatus:'pause'
        })
        this.audioExample.pause();
        this.example.stop();
        setTimeout(() => {
            this.setState({hasClick: false});
        }, 1000);
        let params = {
            time:Math.ceil(this.duration),
            needResult:true,
            sentence: questionInfo.text,
            parameters
        }
        if(type === 'archery'){
            params.centerX = 1148/this.countInit;
            params.centerY = 736/this.countInit;
        }
        else{
            params.centerX = 1120/this.countInit;
            params.centerY = 790/this.countInit;
        }
        this.protectTimer = setTimeout(() => {
            const protectRes = {
                result: 1.5,
                total: 5
            };
            this.evaluateResult(JSON.stringify(protectRes));
        }, (Math.ceil(this.duration) + 3)*1000);
        clientApi.recordTest(params);
        clientApi.eventTracking({eventType:`c2_app_HomeWork_${eventTrackingType}_Record`});
    }

    //接收评测结果
    evaluateResult = (res) => {
        clearTimeout(this.protectTimer);
        const { level0, type } = this.props;
        const _data = decodeParams(res);
        const data = {
            result: _data.result,
            total: _data.total,
            words: _data.fullMessage ? _data.fullMessage.result.words : []
        }
        const score = Math.round(data.result * 20);
        this.setState({ score });
        if(score < 0){
            return clientApi.alertView({
                content: `评测异常(${Number(score)*-1})`,
                confirm: '确认',
                id:'H5_1004'
            });
        }
        if(!level0 && type === 'castle') {
            this.setState({
                words: data.words
            });
        }
        this.timeOutArr.push(
            setTimeout(() => {
                this.props.playResult(score);
                this.timeOutArr.push(
                    setTimeout(() => {
                        this.setStep('step3');
                    }, 3300)
                );
            }, 1000)
        )
    }
    // 接收客户端上传地址回调
    storageEvaluatedAudio = (obj) => {
        const { onStorageEvaluatedAudio } = this.props;
        const { audioUrl } = JSON.parse(obj);
        console.log('音频地址：', audioUrl)
        this.setState({ audioUrl });
        onStorageEvaluatedAudio && onStorageEvaluatedAudio(audioUrl);
    };

    render(){
        const {done, recordStudentStatus, step, recordStatus, words=[], questionInfo} = this.state;
        const { type, isLast } = this.props;
        return(
            <div className={`container question ${type}`}>
                <div className="question_pic" style={{backgroundImage:`url(${questionInfo.picture})`}}/>
                <div className="btn_wrap">
                    <Apng
                        className="sound pointer example"
                        src={exampleIcon}
                        // rate={2}
                        autoPlay={false}
                        onClick={this.playExample}
                        ref={com => (this.example = com)}
                    ></Apng>
                    {/* <div className={`sound icons pointer example ${recordExampleStatus}`} onClick={this.handlePlayExample}></div> */}
                    <div className={`sound icons pointer student ${recordStudentStatus}`} onClick={this.playStudent}></div>
                </div>
                <div className="question_text">
                {words.length?
                    <span style={{marginLeft: 0}}>
                        {
                            words.map((ele,index)=>{
                                if(index !== 0){
                                    ele.word = `${ele.word}`
                                } 
                                return (
                                    <span 
                                        className={`words word${index} ${ele.scores.overall<60? 'red' : ele.scores.overall<80? 'nomal' : 'green'}`}
                                        key={index}
                                    >
                                        {ele.word.replace('$dd$','"')}
                                    </span>
                                )
                            })
                        }
                    </span>
                    :
                    <span className="word_f">{questionInfo.text}</span>
                }
                    
                </div>
                <div className={`complete_icons_wrap ${done?'active':''}`}>
                    <div className={`icons complete_icons reflash`} onClick={()=>{this.restart(false)}}></div>
                    <div className={`icons complete_icons next ${isLast?'last':''}`} onClick={this.nextQuestion} ></div>
                </div>
                <div className={`record_wrap ${!done?'active':''}`}>
                    {step==='step1' &&
                        <div>
                            <Apng
                                className="record_light"
                                src={recordLight}
                                rate={1}
                                autoPlay={true}
                                ref={com => (this.recordLight = com)}
                            />
                            <div className="guide"></div>
                        </div>
                    }
                    <div className={`icons record_btn ${recordStatus}`} ref={com => {this.recordBtn = com}} ></div>
                    <div className="record_btn_hide" onClick={() => {
                        const { step } = this.state;
                        if(step !== 'step1') return false;
                        this.recordTest();
                    }} ></div>
                </div>
                <audio preload='auto' ref={ com => {this.audioExample = com} } src={questionInfo.audio}></audio>
            </div>
        )
    }
}

export default Question;



// WEBPACK FOOTER //
// ./src/template/HomeworkNew/Question.jsx